"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventSender = void 0;
const Log_1 = require("./Log");
const NetworkConfig_1 = require("./NetworkConfig");
const SDKType_1 = require("./SDKType");
const StatsigMetadata_1 = require("./StatsigMetadata");
const VisibilityObserving_1 = require("./VisibilityObserving");
class EventSender {
    constructor(sdkKey, network, emitter, logEventUrlConfig, options) {
        this._sdkKey = sdkKey;
        this._network = network;
        this._emitter = emitter;
        this._options = options;
        this._logEventUrlConfig = logEventUrlConfig;
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    sendBatch(batch) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            let failurePath = 'event_sender_unexpected_exception';
            const transportFailure = {};
            try {
                const isClosing = (0, VisibilityObserving_1._isUnloading)();
                const shouldUseBeacon = isClosing &&
                    this._network.isBeaconSupported() &&
                    ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                failurePath = 'event_sender_pre_logs_flushed_emitter_exception';
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: batch.events,
                });
                failurePath = shouldUseBeacon
                    ? 'event_sender_unexpected_exception'
                    : 'event_sender_post_exception';
                const response = shouldUseBeacon
                    ? this._sendEventsViaBeacon(batch, transportFailure)
                    : yield this._sendEventsViaPost(batch, transportFailure);
                if (response.success) {
                    failurePath = 'event_sender_logs_flushed_emitter_exception';
                    this._emitter({
                        name: 'logs_flushed',
                        events: batch.events,
                    });
                    return response;
                }
                return Object.assign(Object.assign(Object.assign({ success: false, statusCode: response.statusCode, failurePath: response.failurePath }, (response.failureErrorMessage
                    ? { failureErrorMessage: response.failureErrorMessage }
                    : {})), (response.failureDiagnosticBucket
                    ? { failureDiagnosticBucket: response.failureDiagnosticBucket }
                    : {})), (response.failureDiagnosticMetadata
                    ? { failureDiagnosticMetadata: response.failureDiagnosticMetadata }
                    : {}));
            }
            catch (error) {
                Log_1.Log.warn('Failed to send batch:', error);
                return Object.assign(Object.assign(Object.assign({ success: false, statusCode: -1, failurePath: (_c = transportFailure.path) !== null && _c !== void 0 ? _c : failurePath }, (transportFailure.errorMessage
                    ? { failureErrorMessage: transportFailure.errorMessage }
                    : {})), (transportFailure.diagnosticBucket
                    ? { failureDiagnosticBucket: transportFailure.diagnosticBucket }
                    : {})), (transportFailure.diagnosticMetadata
                    ? { failureDiagnosticMetadata: transportFailure.diagnosticMetadata }
                    : {}));
            }
        });
    }
    _sendEventsViaPost(batch, failureInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const result = yield this._network.post(this._getRequestData(batch), failureInfo);
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            if (code === -1) {
                return Object.assign(Object.assign(Object.assign({ success: false, statusCode: -1, failurePath: (_b = failureInfo.path) !== null && _b !== void 0 ? _b : (result === undefined
                        ? 'event_sender_post_returned_undefined'
                        : 'event_sender_post_returned_null') }, (failureInfo.errorMessage
                    ? { failureErrorMessage: failureInfo.errorMessage }
                    : {})), (failureInfo.diagnosticBucket
                    ? { failureDiagnosticBucket: failureInfo.diagnosticBucket }
                    : {})), (failureInfo.diagnosticMetadata
                    ? { failureDiagnosticMetadata: failureInfo.diagnosticMetadata }
                    : {}));
            }
            return { success: code >= 200 && code < 300, statusCode: code };
        });
    }
    _sendEventsViaBeacon(batch, failureInfo) {
        var _a;
        const success = this._network.beacon(this._getRequestData(batch), failureInfo);
        return Object.assign(Object.assign(Object.assign({ success, statusCode: success ? 200 : -1, failurePath: success
                ? undefined
                : (_a = failureInfo.path) !== null && _a !== void 0 ? _a : 'beacon_send_false' }, (!success && failureInfo.errorMessage
            ? { failureErrorMessage: failureInfo.errorMessage }
            : {})), (!success && failureInfo.diagnosticBucket
            ? { failureDiagnosticBucket: failureInfo.diagnosticBucket }
            : {})), (!success && failureInfo.diagnosticMetadata
            ? { failureDiagnosticMetadata: failureInfo.diagnosticMetadata }
            : {}));
    }
    _getRequestData(batch) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: batch.events,
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            preserveFailedStatusCode: true,
            isCompressable: true,
            params: {
                [NetworkConfig_1.NetworkParam.EventCount]: String(batch.events.length),
            },
            headers: {
                'statsig-event-count': String(batch.events.length),
                'statsig-retry-count': String(batch.attempts),
                'statsig-sdk-type': SDKType_1.SDKType._get(this._sdkKey),
                'statsig-sdk-version': StatsigMetadata_1.SDK_VERSION,
            },
            credentials: 'same-origin',
        };
    }
}
exports.EventSender = EventSender;
